import { TeamInvitationState } from '@anm/api/modules/team';
import Image from '@anm/components/image/Image';
import getFromCdn from '@anm/helpers/getFromCdn';
import styled, { css } from 'styled-components';

export const variants: { [key in TeamInvitationState]: ReturnType<typeof css> } = {
  PENDING: css`
    background: #dcf4d9;
    &::before {
      content: 'Invited';
      background-image: url(${getFromCdn('images/icons/time.svg')});
    }
  `,
  REJECTED: css`
    background: #ffe3e3;
    &::before {
      content: 'Declined';
      background-image: url(${getFromCdn('images/data/icons/round-close.svg')});
    }
  `,
  ACCEPTED: css`
    display: none;
  `
};
export const ImageWrapper = styled(Image)`
  border-radius: 50%;
  margin-right: 15px;
  width: 40px;
  height: 40px;
`;
export const UserName = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-right: 5px;
`;
export const Status = styled.div<{ variant: TeamInvitationState }>`
  height: 24px;
  border-radius: 4px;
  text-align: center;
  padding: 0 5px;

  &::before {
    font-weight: 400;
    font-size: 13px;
    line-height: 26px;
    height: 24px;
    display: block;
    background-repeat: no-repeat;
    background-position: 0px 4px;
    background-size: 17px;
    padding-left: 20px;
  }
  ${({ variant }) => variants[variant]}
`;
export const ActionsDropdownContainer = styled.div`
  display: flex;
  justify-content: right;
`;
export const Email = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #8b9499;
  text-align: left;
`;
export const Role = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-left: auto;
`;

export const Header = styled.section`
  display: flex;
  flex-direction: column;
  align-items: start;
`;
export const Limit = styled.section<{ isLink: boolean }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #8b9499;

  ${({ isLink }) =>
    isLink &&
    css`
      cursor: pointer;
      &:hover {
        color: #2294df;
      }
    `}
`;

export const Grid = styled.div`
  margin-top: 20px;
  padding: 30px 20px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 5fr 3fr 2fr 1fr;
  grid-row-gap: 30px;
  width: 100%;
  border: 1px solid rgba(0, 56, 87, 0.2);

  & > * {
    display: flex;
    align-items: center;
  }
`;
const Wrapper = styled.section`
  margin-top: 50px;
`;

export default Wrapper;
